/**
 * The not-found page's count of a visit: `POST /home/track-404`, the address
 * that matched no page and where the visitor came from. The backend logs it
 * to CloudWatch, where a spike in broken links can raise an alarm; nothing
 * reads the answer.
 *
 * The web page sent this through axios with no schema until #1207 "WEB:
 * sitemap of public pages, and missing pages marked missing" touched the
 * page; it goes through RTK Query now, and the backend reads the body with
 * the same schema.
 */
import { z } from 'zod';

export const NOT_FOUND_ROUTES = {
  /** POST: count one visit to an address with no page (TrackNotFoundRequestSchema). Public. */
  track: 'home/track-404',
} as const;

export const TrackNotFoundRequestSchema = z.object({
  /** The address the visitor asked for. */
  path: z.string().min(1),
  /** The page that linked here, or null when the browser says none. */
  referrer: z.string().nullable(),
});
export type TrackNotFoundRequest = z.infer<typeof TrackNotFoundRequestSchema>;
